var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<ul v-if=\"store.auth\"><li v-repeat=\"links\"><a v-link=\"{name: name}\">{{ text }}</a></li></ul>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/menu-right/template.jade
 ** module id = 205
 ** module chunks = 0
 **/